<template>
    <div>
  
      <div class="text-center m-0 d-flex mt-5">
        <!-- Video element to show the camera feed -->
        
        <video ref="video" style="max-width:1000px;border-radius: 16px;
border: 10px solid #fff;
background: rgba(255, 255, 255, 0.90);" height="500px" autoplay muted></video>

        <img ref="processedFrame" :src="processedFrameSrc" alt="Processed frame will appear here" class="" style="max-width:1000px;border-radius: 16px;
border: 10px solid #fff;
background: rgba(255, 255, 255, 0.90);" height="500px"/>
      </div>
  
      <!-- Image element to display the processed frame -->
     
    </div>
  </template>
  
  <script>
  export default {
    name: "YoloV8ObjectDetection",
    data() {
      return {
        processedFrameSrc: "data:image/jpeg;base64,", // Initial empty image source
      };
    },
    mounted() {
      this.initializeCamera();
      // Send frames at a set interval (every 200ms)
      this.frameInterval = setInterval(this.sendFrame, 200);
    },
    beforeDestroy() {
      // Cleanup the camera stream and clear the interval when the component is destroyed
      if (this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach((track) => track.stop());
      }
      clearInterval(this.frameInterval);
    },
    methods: {
      // Initialize the camera and start the video stream
      initializeCamera() {
        const video = this.$refs.video;
  
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          alert("Camera access is not supported by this browser. Please try a different browser.");
          return;
        }
  
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            this.videoStream = stream;
            video.srcObject = stream;
          })
          .catch((error) => {
            console.error("Error accessing the camera:", error);
          });
      },
  
      // Capture the frame and send it to the server for processing
      sendFrame() {
        const video = this.$refs.video;
  
        // Only proceed if the video is playing
        if (video.paused || video.ended) return;
  
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
        canvas.toBlob((blob) => {
          const formData = new FormData();
          formData.append('file', blob, 'frame.jpg');
  
          // Send the frame to the server
          fetch('https://devai.mywire.org' + '/idx_process_frame', {
            method: 'POST',
            body: formData,
          })
            .then((response) => response.blob())
            .then((blob) => {
              const url = URL.createObjectURL(blob);
              this.processedFrameSrc = url; // Update the processed image source
            })
            .catch((error) => {
              console.error("Error sending frame:", error);
            });
        }, 'image/jpeg');
      },
    },
  };
  </script>
  
  <style scoped>
  /* You can add custom styles here if needed */
  h1 {
    text-align: center;
    margin-top: 20px;
  }
  
  video {
    display: block;
    margin: 20px auto;
  }
  
  img {
    display: block;
    margin: 20px auto;
    max-width: 100%;
  }
  </style>
  